import {styles} from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../buttons/button.yesno";
import React from "react";
import {ToolTipPerso} from "../selects/tooltip_perso";

// example of component use:
//      <PrimoAccedant
//          handleChange={handleChange}
//          setPrimoAccedant={setPrimoAccedant}
//      />

const PrimoAccedant = (props) => {

    return (
        <div style={styles.cardRow}>
            <div style={styles.cardElemVerticalyCenter}>L’acquéreur est-il « primo accédant » ?
                <ToolTipPerso
                    title={
                        "Le bien acquis constitue pour l’acquéreur une première propriété au sens du I de l’article L. 31-10-3 du code de la construction et de l’habitation et qu’il est destiné à l’usage de sa résidence principale."
                    }
                />
            </div>
            <div>
                <ButtonYesno handleChange={props.handleChange} setter={props.setPrimoAccedant} fieldUndefined={false} defaultValue={0} />
            </div>
        </div>
    );
};

export default PrimoAccedant;